var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-separator"},[_c('div',{staticClass:"separator-content"},[_c('div',{staticClass:"separator-line"}),(_vm.title)?_c('h3',{staticClass:"separator-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"separator-line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }